import { storeToRefs } from 'pinia';

import { useTeamsStore } from '@/modules/settings/stores/teams';
import MODALS from '@/modules/shared/utils/modals_enum';
import type { ITeams, IcreateTeams, IdeleteTeams } from '@/modules/settings/interfaces/Teams';

const useTeams = () => {
    const storeTeams = useTeamsStore();
    const { teams, isErrorGet } = storeToRefs(storeTeams);

    const getTeams = async (): Promise<ITeams[]> => {
        if (teams.value.length === 0) {
            storeTeams.setTeams([
                {
                    id: '540735d2-e94c-4d05-a4f0-86c1c5700805',
                    name: 'Accounting',
                    members: [
                        {
                            'email': 'dev.account18@sample.net',
                            'id': '8ab49fc2-0d6f-4c68-9729-92c02390653a'
                        },
                        {
                            'email': 'qa.user13@test.org',
                            'id': '0763d4b1-75fb-4c3c-b47e-ebff3d4f71a8'
                        },
                        {
                            'email': 'dummy.account14@sample.net',
                            'id': 'd10c4a8a-f5c9-4ae9-ad9b-a1950ff634c2'
                        }
                    ],
                    created: '2023-07-18T12:48:18.838755Z',
                    managers: [
                        {
                            'email': 'random.user16@example.org',
                            'id': 'f29a5e5b-4aee-40d6-91a6-eaf446c65a61'
                        }
                    ]
                },
                {
                    id: '540735d2-e94c-4d05-a4f0-86c1c5700804',
                    name: 'Customer Service',
                    members: [
                        {
                            'email': 'gvilatte@emailmeter.com',
                            'id': 'aa777cbc-3368-43a7-abf9-b2b8992fd61a'
                        },
                        {
                            'email': 'carlos@emailmeter.com',
                            'id': 'bf4b1304-9746-4354-89cd-502e907aea1f'
                        }
                    ],
                    created: '2023-07-18T12:48:18.838755Z',
                    managers: [
                        {
                            'email': 'random.user16@example.org',
                            'id': 'f29a5e5b-4aee-40d6-91a6-eaf446c65a61'
                        }
                    ]
                },
                {
                    id: '540735d2-e94c-4d05-a4f0-86c1c5700803',
                    name: 'HR',
                    members: [
                        {
                            'email': 'test.dummy25@sample.com',
                            'id': '6ea71899-459a-493b-acf5-83dfe89bf370'
                        },
                        {
                            'email': 'test.qa21@test.net',
                            'id': 'a43e03ad-19f5-4681-ac1b-3957bea030a9'
                        }
                    ],
                    created: '2023-07-18T12:48:18.838755Z',
                    managers: [
                        {
                            'email': 'random.user16@example.org',
                            'id': 'f29a5e5b-4aee-40d6-91a6-eaf446c65a61'
                        }
                    ]
                },
                {
                    id: '540735d2-e94c-4d05-a4f0-86c1c5700802',
                    name: 'Sales',
                    members: [
                        {
                            'email': 'kelly.kapoor@dundermifflin.com',
                            'id': '8ab49fc2-0d6f-4c68-9729-92c02390653a'
                        },
                        {
                            'email': 'stanley.hudson@dundermifflin.com',
                            'id': 'f29a5e5b-4aee-40d6-91a6-eaf446c65a61'
                        },
                        {
                            'email': 'phyllis.vance@dundermifflin.com',
                            'id': '0763d4b1-75fb-4c3c-b47e-ebff3d4f71a8'
                        },
                        {
                            'email': 'dummy.account14@sample.net',
                            'id': 'd10c4a8a-f5c9-4ae9-ad9b-a1950ff634c2'
                        },
                        {
                            'email': 'dev28@test.com',
                            'id': '17c9b9ed-282b-4694-a1e7-1fe17526e3b4'
                        }
                    ],
                    created: '2023-07-18T12:48:18.838755Z',
                    managers: [
                        {
                            'email': 'random.user16@example.org',
                            'id': 'f29a5e5b-4aee-40d6-91a6-eaf446c65a61'
                        }
                    ]
                }
            ]);
        }
        return await new Promise<ITeams[]>((resolve) => {
            resolve(teams.value);
        });
    };

    const createTeams = async (teamsData: IcreateTeams): Promise<void> => {
        if (teamsData.id) deleteDemoTeams({ data: { teams: [teamsData.id] } });
        const team = {
            id: teamsData.id ? teamsData.id : Math.random().toString(),
            name: teamsData.name,
            members: teamsData.members,
            created: String(new Date())
        };

        storeTeams.setTeams([...teams.value, team]);
    };

    const deleteDemoTeams = async (usersData: IdeleteTeams) => {
        usersData.data.teams.forEach((team) => {
            const indexForDelete = teams.value.findIndex((t) => t.id === team);
            if (indexForDelete !== -1) {
                const arrayUsers = [...teams.value];
                arrayUsers.splice(indexForDelete, 1);
                storeTeams.setTeams([...arrayUsers]);
            }
        });
    };

    const deleteTeams = async (teamsData: IdeleteTeams): Promise<void> => deleteDemoTeams(teamsData);

    return {
        teams,
        isErrorGet,

        // Method
        getTeams,
        createTeams,
        deleteTeams,

        removeData: (teamsIds: string[]) => {
            const maxLength = 50;
            const ts: string[] = [];
            teamsIds.forEach((t) => {
                teams.value.forEach((team: { id: string; name: string }) => {
                    if (t === team.id) ts.push(team.name);
                });
                return t.length > maxLength ? t.slice(0, maxLength) + '...' : t;
            });

            return {
                name: MODALS.removeModal,
                data: {
                    type: 'teams',
                    title: `Are you sure you want to remove ${teamsIds.length > 1 ? 'these teams' : 'this team'}?`,
                    text: `The "${ts.join(', ')}" ${teamsIds.length > 1 ? 'teams' : 'team'} will be permanently deleted, but the mailboxes inside it will still be tracked.`,
                    data: teamsIds
                }
            };
        }
    };
};

export default useTeams;
